import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTruck, faEdit, faFile, faMapMarkerAlt, faFileAlt, faEye } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';
import moment from 'moment';

//Components
import TabelaVeiculos from './TabelaVeiculos';

//Helpers
import mascaras from '../../../../helpers/mascaras';

import { abrirPDF } from '../../../../helpers/abrirPDF';

export default function FichaTransportadorContainer({ transportador, editTransportador, veiculos, editVeiculos }) {


    return (
        <div style={{ color: "#666" }}>
            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Identificação do transportador</span>
                {editTransportador && <button style={{ border: "none", backgroundColor: "transparent", color: "#fff" }} onClick={editTransportador}><FontAwesomeIcon icon={faEdit} className="m-0 p-0" /></button>}
            </h5>

            <Row>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Fantasia: </span>{transportador.fantasia ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Razão social: </span>{transportador.razao ?? "Não informado"}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">CNPJ: </span>{transportador.cnpj ? mascaras.cnpjMask(transportador.cnpj) : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">E-mail: </span>{transportador.email ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Responsável: </span>{transportador.responsavel ?? "Não informado"}</p>
                </Col>


            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Fone: </span>{transportador.fone ? mascaras.celularMask(transportador.fone) : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Celular: </span>{transportador.celular ? mascaras.celularMask(transportador.celular) : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Inscrição: </span>{transportador.inscricao ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Numero do processo: </span>{transportador.numeroProcesso ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Situação: </span>{transportador.situacao ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Código do cadastro: </span>{transportador?.codigoCadastro ?? ""}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Realizar Coleta Avulsa? </span>{transportador.naoRealizaColetaAvulso?.toString() == "true" ? "Não" : "Sim"}</p>
                </Col>

                <Col md="12" lg="4">
                    <p><span className="fw-bold">Utilizar QRCode na Coleta? </span>{transportador.realizaColetaPorQRCode?.toString() == "true" ? "Sim" : "Não"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Divulgar na Internet? </span>{transportador.divulgarInternet}</p>
                </Col>
            </Row>

            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faFile} className="me-2" /> Credenciamento</span></h5>
            <Row>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Número de credenciamento: </span> {transportador.credenciamentoNumero}</p>
                </Col>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Validade do credenciamento: </span> {moment(transportador.credenciamentoValidade).format("DD/MM/YYYY")}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Número licença da operação </span> {transportador.operacaoNumero}</p>
                </Col>
                <Col md="12" lg="6">
                    <p><span className="fw-bold">Validade da licença: </span> {moment(transportador.operacaoValidade).format("DD/MM/YYYY")}</p>
                </Col>
            </Row>

            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
                <span><FontAwesomeIcon icon={faFile} className="me-2" /> Documentos</span>
            </h5>
            <Row>
                {transportador?.documentos.map((documento, index) => (
                    <Col lg={3} key={index} className="mb-3">
                        <div className="card shadow h-100">
                            <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="d-flex flex-column align-items-center">
                                    <label htmlFor={`file-upload-${index}`} className="mb-3">
                                        <FontAwesomeIcon icon={faFileAlt} className="text-success" size="4x" />
                                    </label>
                                </div>

                                <div className="mb-3">
                                    <strong>{documento.identificacao || "Documento"}</strong>
                                </div>

                                <button className="btn btn-primary btn-sm mt-auto" onClick={() => {
                                    if (documento.arquivo.includes(".pdf"))
                                        window.open(documento.arquivo, "_blank")
                                    else
                                        abrirPDF(documento.arquivo);
                                }}>
                                    <FontAwesomeIcon icon={faEye} /> Visualizar
                                </button>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}> <span><FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" /> Endereço</span></h5>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">CEP: </span> {transportador.cep ? mascaras.cepMask(transportador.cep) : "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Cidade: </span> {transportador.cidade ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">UF: </span> {transportador.uf ?? "Não informado"}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Bairro: </span> {transportador.bairro ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Logradouro: </span> {transportador.logradouro ?? "Não informado"}</p>
                </Col>
                <Col md="12" lg="4">
                    <p><span className="fw-bold">Número: </span> {transportador.numero ?? "Não informado"}</p>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="12">
                    <p><span className="fw-bold">Complemento: </span> {transportador.complemento ?? "Não informado"}</p>
                </Col>
            </Row>
            <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex align-items-center justify-content-between" style={{ color: "#fff" }}><span><FontAwesomeIcon icon={faTruck} className="me-2" /> Veículos</span>{editVeiculos && <button style={{ border: "none", backgroundColor: "transparent", color: "#fff" }} onClick={editVeiculos}><FontAwesomeIcon icon={faEdit} className="m-0 p-0" /></button>} </h5>
            <TabelaVeiculos ficha veiculos={veiculos} paging={false} />


        </div >
    )

}